import React from "react";
import { i18n } from "../../../translate/i18n";

import * as S from "./ChartSeries.style";

import { 
  CustomHeading,
  CustomText
} from "../../StyledComponents/styleComponents.index";

import PropTypes from "prop-types";
import { createPercentFormatter } from "../../../utils/formatter/formatter";

export function ChartSeries({ series }) {
  const { t } = i18n;
  const { driver, value } = series;

  return (
    <S.Grid>
      <S.TextContainer>
        <CustomText textAlign="end" size="xs" margin="0" lineHeight="120%">
          {t(driver)}
        </CustomText>
      </S.TextContainer>

      <S.OuterBar>
        <S.InnerBar width={value} />
      </S.OuterBar>

      <CustomHeading color="orange" size="md">
        {createPercentFormatter({ minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value / 100)}
      </CustomHeading>
    </S.Grid>
  );
}

ChartSeries.propTypes = {
  series: PropTypes.shape({
    driver: PropTypes.string,
    value: PropTypes.number
  })
};